import { render, staticRenderFns } from "./NavConstruction.vue?vue&type=template&id=677866b5&"
import script from "./NavConstruction.vue?vue&type=script&lang=js&"
export * from "./NavConstruction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports